module.exports = __webpack_public_path__ + "assets/img/4_17_big.5af83550.jpg";